import { Resource } from './resource';
import { Filter } from './filters';
import { MultiPointInstallation } from './api';
type MPISensor = MultiPointInstallation['sensors'][0];

export type MultiPointInstallationCreationState = {
  open: boolean;

  setup: {
    name: string;
    height: string;
  };
  reorder: {
    positions: Array<{
      serialNumber: MPISensor['sensor_serial'];
      spacingRight: string;
      doorwayName: string;
    }>;
  };

  resource: Resource<null>; // Used to track response status of creation process
};

export enum MultiPointInstallationCreationActionTypes {
  MULTI_POINT_INSTALLATION_CREATION_OPEN = 'MULTI_POINT_INSTALLATION_CREATION_OPEN',

  MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_NAME = 'MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_NAME',
  MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_HEIGHT = 'MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_HEIGHT',

  MULTI_POINT_INSTALLATION_CREATION_SET_SPACING_RIGHT = 'MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_SPACING_RIGHT',

  MULTI_POINT_INSTALLATION_CREATION_REMOVE_SENSOR = 'MULTI_POINT_INSTALLATION_CREATION_REMOVE_SENSOR',
  MULTI_POINT_INSTALLATION_CREATION_ADD_SENSORS = 'MULTI_POINT_INSTALLATION_CREATION_ADD_SENSORS',
  MULTI_POINT_INSTALLATION_CREATION_SET_SENSOR_ORDER = 'MULTI_POINT_INSTALLATION_CREATION_SET_SENSOR_ORDER',

  MULTI_POINT_INSTALLATION_CREATION_LOADING = 'MULTI_POINT_INSTALLATION_CREATION_LOADING',
  MULTI_POINT_INSTALLATION_CREATION_ERROR = 'MULTI_POINT_INSTALLATION_CREATION_ERROR',
  MULTI_POINT_INSTALLATION_CREATION_COMPLETE = 'MULTI_POINT_INSTALLATION_CREATION_COMPLETE',
}

export type MultiPointInstallationCreationAction =
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_OPEN;
      sensors: Array<{
        serialNumber: MPISensor['sensor_serial'];
        doorwayName: string;
      }>;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_NAME;
      name: string;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_HEIGHT;
      height: string;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SET_SENSOR_ORDER;
      serialNumbers: Array<MPISensor['sensor_serial']>;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SET_SPACING_RIGHT;
      serialNumber: MPISensor['sensor_serial'];
      spacingRight: string;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_REMOVE_SENSOR;
      serialNumber: string;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_ADD_SENSORS;
      sensors: Array<{ serialNumber: string; doorwayName: string }>;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_LOADING;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_ERROR;
      error: any;
    }
  | {
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_COMPLETE;
      id: MultiPointInstallation['id'];
    };
